<template>
  <div class="flex flex-col gap-4 w-full h-full rounded-lg">
    <div class="absolute inset-0 flex items-center w-full h-full justify-center z-10">
      <div
        class="flex items-center justify-center w-24 h-24 rounded-full bg-[#f0f5f8]"
        :class="{ '!w-40 !h-40 bg-[#f0f5f8]': isDragging }"
        @dragover.prevent="onDragOver"
        @dragleave="onDragLeave"
        @drop.prevent="onDrop">
        <div
          class="flex items-center justify-center w-16 h-16 rounded-full border border-dashed border-common-grey bg-white flex-shrink-0"
          :class="{ '!w-32 !h-32': isDragging }">
          <input class="custom-file-input" accept=".xlsx,.xls,.csv,.numbers" type="file" @change="setFile">
          <CloudUpload class="w-12 h-12" :class="{ 'w-24 h-24': isDragging }" color="#899399" />
        </div>
      </div>
    </div>
    <div class="flex w-full h-full gap-4">
      <div class="w-1/2 flex flex-col bg-white rounded-xl p-2">
        <span class="font-bold text-[20px]">{{ $t("Documents & files") }}</span>
        <div class="w-full flex flex-wrap gap-y-3">
          <div
            v-for="file in resources.filter((f) => f.group == 'files')"
            :key="file.id"
            class="p-2 w-1/2 h-[80px] flex items-center gap-4 rounded-xl bg-[#F5F5F5]">
            <div class="relative flex -mt-4 w-12 h-12">
              <Avatar :user="Record.from({})" class="w-full h-full" />
              <div class="absolute -bottom-4 -right-2 flex items-center justify-center w-10 h-10 rounded-full bg-[#579FBB]">
                <DocFileIcon class="w-7 h-7" />
              </div>
            </div>
            <div class="flex flex-col">
              <span class="font-semibold text-[16px]">{{ file.name }}</span>
              <span class="text-common-grey text-[14px]">{{ file.created_date }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="w-1/2 flex flex-col bg-white rounded-xl p-2">
        <span class="flex flex-row-reverse w-fill font-bold text-[20px]">{{ $t("Links & URLs") }}</span>
        <div class="w-full flex flex-wrap gap-y-3">
          <div
            v-for="file in resources.filter((f) => f.group == 'urls')"
            :key="file.id"
            class="p-2 w-1/2 h-[80px] flex items-center gap-4 rounded-xl bg-[#F5F5F5]">
            <div class="relative flex -mt-4 w-12 h-12">
              <Avatar :user="Record.from({})" class="w-full h-full" />
              <div class="absolute -bottom-4 -right-2 flex items-center justify-center w-10 h-10 rounded-full bg-[#579FBB]">
                <DocFileIcon class="w-7 h-7" />
              </div>
            </div>
            <div class="flex flex-col">
              <span class="font-semibold text-[16px]">{{ file.name }}</span>
              <span class="text-common-grey text-[14px]">{{ file.created_date }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex w-full h-full gap-4">
      <div class="w-1/2 flex flex-col bg-white rounded-xl p-2">
        <span class="font-bold text-[20px]">{{ $t("Images & videos") }}</span>
        <div class="w-full flex flex-wrap gap-y-3">
          <div
            v-for="file in resources.filter((f) => f.group == 'images')"
            :key="file.id"
            class="p-2 w-1/2 h-[80px] flex items-center gap-4 rounded-xl bg-[#F5F5F5]">
            <div class="relative flex -mt-4 w-12 h-12">
              <Avatar :user="Record.from({})" class="w-full h-full" />
              <div class="absolute -bottom-4 -right-2 flex items-center justify-center w-10 h-10 rounded-full bg-[#579FBB]">
                <DocFileIcon class="w-7 h-7" />
              </div>
            </div>
            <div class="flex flex-col">
              <span class="font-semibold text-[16px]">{{ file.name }}</span>
              <span class="text-common-grey text-[14px]">{{ file.created_date }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="w-1/2 flex flex-col bg-white rounded-xl p-2">
        <span class="flex flex-row-reverse w-fill font-bold text-[20px]">{{ $t("Other") }}</span>
        <div class="w-full flex flex-wrap gap-y-3">
          <div
            v-for="file in resources.filter((f) => f.group == 'other')"
            :key="file.id"
            class="p-2 w-1/2 h-[80px] flex items-center gap-4 rounded-xl bg-[#F5F5F5]">
            <div class="relative flex -mt-4 w-12 h-12">
              <Avatar :user="Record.from({})" class="w-full h-full" />
              <div class="absolute -bottom-4 -right-2 flex items-center justify-center w-10 h-10 rounded-full bg-[#579FBB]">
                <DocFileIcon class="w-7 h-7" />
              </div>
            </div>
            <div class="flex flex-col">
              <span class="font-semibold text-[16px]">{{ file.name }}</span>
              <span class="text-common-grey text-[14px]">{{ file.created_date }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CloudUpload } from "lucide-vue-next"
import DocFileIcon from "@/components/shared/icons/DocFileIcon.vue"
import Avatar from "@/components/shared/Avatar.vue"
import { Record } from "@/models/record"

export default {
  components: {
    CloudUpload,
    DocFileIcon,
    Avatar
  },
  props: {},
  data() {
    return {
      Record,
      isDragging: false, // To keep track of the drag state
      current_file: null,
      resources: [
        { id: 1, created_date: "02/13/2024", name: "call notes 2022", group: "files", type: "doc" },
        { id: 2, created_date: "02/13/2024", name: "netflix_onboarding_2...", group: "files", type: "pdf" },
        { id: 3, created_date: "02/13/2024", name: "random notes", group: "files", type: "txt" },
        { id: 3, created_date: "02/13/2024", name: "logo", group: "files", type: "png" },
        { id: 4, created_date: "02/13/2024", name: "records data", group: "files", type: "xlsx" },
        { id: 5, created_date: "02/13/2024", name: "json file", group: "files", type: "json" },
        { id: 6, created_date: "02/13/2024", name: "document", group: "files", type: "doc" },
        { id: 7, created_date: "02/13/2024", name: "call notes 2023", group: "urls", type: "doc" },
        { id: 8, created_date: "02/13/2024", name: "call notes 2022", group: "urls", type: "doc" },
        { id: 9, created_date: "02/13/2024", name: "call notes 2021", group: "urls", type: "doc" },
        { id: 10, created_date: "02/13/2024", name: "call notes 2020", group: "urls", type: "doc" },
        { id: 11, created_date: "02/13/2024", name: "client logo", group: "images", type: "png" },
        { id: 12, created_date: "02/13/2024", name: "data backup", group: "other", type: "xlxs" },
        { id: 13, created_date: "02/13/2024", name: "data backup 23", group: "other", type: "xlxs" }
      ]
    }
  },
  created() {},
  methods: {
    onDragOver() {
      this.isDragging = true // Indicate that a file is being dragged over the area
    },
    onDragLeave() {
      this.isDragging = false // Revert the drag state when the file leaves
    },
    onDrop(event) {
      this.isDragging = false // Reset the state upon dropping
      this.current_file = event.dataTransfer.files[0] // Extract the files from the drop event

      // Handle the files (e.g., upload them to a server or display a preview)
      //console.log('Dropped files:', files)
    },
    setFile(event) {
      //console.log(event.target.files[0])
      this.current_file = event.target.files[0]
    }
  }
}
</script>
<style>
/* Animation to highlight the drop zone when dragging over it */
.bg-green-100 {
  transition: background-color 0.3s ease-in-out;
}
.border-green-500 {
  transition: border-color 0.3s ease-in-out;
}
</style>
